/**
 * Escape user-provided plain text for safe insertion into HTML email templates.
 */
export function escapeHtmlForEmail(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Render plain text with line breaks in HTML email. Newlines become <br /> after escaping.
 */
export function plainTextToEmailHtml(text: string): string {
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  return escapeHtmlForEmail(normalized).replace(/\n/g, '<br />');
}

/**
 * True when the string likely contains HTML tags (so we should not escape the whole block).
 * Conservative so phrases like "3 < 5" are still treated as plain text.
 */
export function looksLikeHtmlFragment(text: string): boolean {
  const s = text.trim();
  if (!s) return false;
  if (/<\/\s*[a-zA-Z]/.test(s)) return true;
  if (/<\s*[a-zA-Z][\w-]*(?:\s|\/?>|>)/.test(s)) return true;
  if (/<\s*[!?]/.test(s)) return true;
  return false;
}

/**
 * Campaign / broadcast body: plain text gets escaped and newlines become &lt;br /&gt;;
 * content that already looks like HTML is passed through unchanged.
 */
export function broadcastMessageContentToEmailHtml(content: string): string {
  if (!content.trim()) return '';
  if (looksLikeHtmlFragment(content)) {
    return content;
  }
  return plainTextToEmailHtml(content);
}
